import PropTypes from 'prop-types';
import { Badge } from 'react-bootstrap';
import SoftBadge from 'components/common/SoftBadge';

// Colour tokens stored on sponsorship_status.color. Falcon has soft variants
// for most; purple and magenta are not theme colours, so they get inline hex.
export const STATUS_COLORS = {
  red: { variant: 'danger' },
  orange: { variant: 'warning' },
  green: { variant: 'success' },
  blue: { variant: 'primary' },
  cyan: { variant: 'info' },
  grey: { variant: 'secondary' },
  purple: { hex: '#6f42c1', soft: '#e9e0f7' },
  magenta: { hex: '#d63384', soft: '#fbe0ec' }
};

// Legacy fallback for status rows created before colours existed
const keywordVariant = status => {
  const s = (status || '').toLowerCase();
  if (s.includes('urgent') || s.includes('replacement')) return 'danger';
  if (s.includes('partial')) return 'warning';
  if (s.includes('ready')) return 'success';
  if (s.includes('fully') || s.includes('sponsored')) return 'primary';
  if (s.includes('hold')) return 'info';
  return 'secondary';
};

export const statusVariant = (status, color) =>
  STATUS_COLORS[color]?.variant || keywordVariant(status);

const StatusBadge = ({ status, color, hidden, pill = false, className }) => {
  if (!status) return <>&mdash;</>;
  const token = STATUS_COLORS[color];
  const label = hidden ? `${status} (hidden)` : status;

  if (token?.hex) {
    return (
      <Badge
        pill={pill}
        className={className}
        style={{ backgroundColor: token.soft, color: token.hex }}
      >
        {label}
      </Badge>
    );
  }
  return (
    <SoftBadge
      bg={statusVariant(status, color)}
      pill={pill}
      className={className}
    >
      {label}
    </SoftBadge>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string,
  color: PropTypes.string,
  hidden: PropTypes.bool,
  pill: PropTypes.bool,
  className: PropTypes.string
};

export default StatusBadge;
